import { connect } from "react-redux";

import Overview from "../../components/main_components/overview";
import { regulationStandardClick } from  "../../actions/focus_view";

const mapStateToProps = (state) => {
  const data = state.loading.data;
  const noParameters = state.filters.parameters.selectedValues.length === 0;
  const purpose = state.filters.purpose.selectedValue;
  // The overview matrix (~1,278 params × ~40 countries ≈ 116k DOM nodes) froze the main thread ~2s
  // when it rendered the pre-fetch data on the first parameter selection (the "first selection takes
  // ~10s" report). Pass the picker-open state and the in-flight-fetch flag so the Overview can skip
  // building the matrix while the user is still picking (it's off-screen) or while a re-fetch is
  // narrowing the data (the current data is stale) — see overview.js.
  const panelOpen = state.filters.showParametersPanel;
  const isLoading = state.loading.showLoadingOverlay;

  return { ...data, noParameters, purpose, panelOpen, isLoading };
};

const mapDispatchToProps = dispatch => ({
  regulationStandardClick: regulationStandardClick(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
